import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function getRoleHome(role) {
  if (role === 'buyer') return '/discover';
  if (role === 'agent') return '/agent';
  if (role === 'seller') return '/seller';
  return '/admin';
}

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-full border-4 border-navy-500 border-t-transparent animate-spin" style={{ borderColor: '#0A192F', borderTopColor: 'transparent' }} />
          <p className="text-slate-500 font-medium">Loading Goldielocks...</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (role && user.role !== role) {
    return <Navigate to={getRoleHome(user.role)} replace />;
  }

  return children;
}
